// Villanova University's undergraduate majors (#2839). Read on 2026-10-01
// from the official 2026-2027 Undergraduate Catalog's Programs list
// (live-villanova-catalog.pantheonsite.io/programs, the catalog the
// Provost's Academic Catalogs page at villanova.edu links as the
// "2026-2027 Undergraduate Course Catalog"). The catalog is hosted off
// villanova.edu, so each group cites the Provost's page that links it.
// Kept: every program whose degree type is a bachelor's (BA, BS, BBA, BIS,
// BSN), under the college its catalog page names. Departures: the catalog's
// list does not group by college, so the college is the first one each
// program's own catalog page names. Folded into their major: the nine
// Secondary Education teaching concentrations, Chemistry with Biochemistry
// Concentration, and Nursing, B.S.N., Honors. Left out: minors (including
// Real Estate Minor, which the list tags with the BBA), certificates, the
// Express and Flex second-degree BSN programs, the Liberal Arts major at SCI
// Phoenix, associate degrees and graduate programs. The three business
// co-majors keep the catalog's "Co-Major" names.
const majors = {
    "slug": "villanova-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Villanova's official 2026-2027 Undergraduate Catalog, grouped by the college that offers it, with the degree it leads to. Concentrations and the honors version of Nursing are folded into their major; minors, certificates, the second-degree nursing programs, the Liberal Arts major offered at SCI Phoenix, associate degrees and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Liberal Arts and Sciences",
            "source": {
                "label": "Villanova 2026-2027 Undergraduate Catalog (from the Provost's Academic Catalogs page), College of Liberal Arts and Sciences",
                "url": "https://www.villanova.edu/university/provost/catalogs.html"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "Arab and Islamic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Astronomy & Astrophysics",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chinese Studies",
                    "degree": "BA"
                },
                {
                    "name": "Classical Studies",
                    "degree": "BA"
                },
                {
                    "name": "Cognitive and Behavioral Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Comprehensive Science",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Criminology",
                    "degree": "BA"
                },
                {
                    "name": "Cultural Studies",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": "BA"
                },
                {
                    "name": "Gender and Women's Studies",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Humanities",
                    "degree": "BA"
                },
                {
                    "name": "Individually Designed",
                    "degree": "BA or BS"
                },
                {
                    "name": "Irish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Japanese Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latin American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Liberal Arts",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Peace and Justice",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Public Service & Administration",
                    "degree": "BA"
                },
                {
                    "name": "Russian Area Studies",
                    "degree": "BA"
                },
                {
                    "name": "Secondary Education",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Theology and Religious Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Villanova School of Business",
            "source": {
                "label": "Villanova 2026-2027 Undergraduate Catalog (from the Provost's Academic Catalogs page), Villanova School of Business",
                "url": "https://www.villanova.edu/university/provost/catalogs.html"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Analytics & Artificial Intelligence Co-Major",
                    "degree": "BBA"
                },
                {
                    "name": "Business Analytics Co-Major",
                    "degree": "BBA"
                },
                {
                    "name": "Economics",
                    "degree": "BBA"
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "International Business Co-Major",
                    "degree": "BBA"
                },
                {
                    "name": "Management",
                    "degree": "BBA"
                },
                {
                    "name": "Management Information Systems",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Real Estate",
                    "degree": "BBA"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "Villanova 2026-2027 Undergraduate Catalog (from the Provost's Academic Catalogs page), College of Engineering",
                "url": "https://www.villanova.edu/university/provost/catalogs.html"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "M. Louise Fitzpatrick College of Nursing",
            "source": {
                "label": "Villanova 2026-2027 Undergraduate Catalog (from the Provost's Academic Catalogs page), M. Louise Fitzpatrick College of Nursing",
                "url": "https://www.villanova.edu/university/provost/catalogs.html"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "College of Professional Studies",
            "source": {
                "label": "Villanova 2026-2027 Undergraduate Catalog (from the Provost's Academic Catalogs page), College of Professional Studies",
                "url": "https://www.villanova.edu/university/provost/catalogs.html"
            },
            "majors": [
                {
                    "name": "Entrepreneurship",
                    "degree": "BIS"
                },
                {
                    "name": "General Studies",
                    "degree": "BIS"
                },
                {
                    "name": "Human Resource Management",
                    "degree": "BIS"
                },
                {
                    "name": "Information Systems and Technology",
                    "degree": "BIS"
                },
                {
                    "name": "Leadership",
                    "degree": "BA or BIS"
                },
                {
                    "name": "Organizational Development & Management",
                    "degree": "BIS"
                },
                {
                    "name": "Public Relations and Advertising",
                    "degree": "BA or BIS"
                },
                {
                    "name": "Public Service & Administration",
                    "degree": "BIS"
                }
            ]
        }
    ]
};

export default majors;
